import ContainerNotes from './ContainerNotes'

export default ContainerNotes
